import React, { useState, useRef, useMemo } from 'react'
import { Model } from 'survey-core'
import { Survey } from 'survey-react-ui'
// import 'survey-core/defaultV2.min.css'

import { useConvertSurvey } from '../hooks/useConvertSurvey'
import { useSubmitAnswers } from '../hooks/useSubmitAnswers'
import 'survey-core/i18n/traditional-chinese'

const Agree = ({
  setAc,
  setTk,
  ac,
  tk,
  pid,
  setIsLoading,
  setCompletionMessage,
}) => {
  const [myAgreeJson, setMyAgreeJson] = useState(null)
  // 需要登入嗎
  const requiresLogin = {
    login: false,
    title: '員工編號（邁達特：MA、啟迪：GI、聚上雲：EP、逐鹿：GU）',
    placeholder: 'MA00000',
    alert: '員工編號有誤，請重新登入，謝謝',
  }
  const [imagesReadingTime, setImagesReadingTime] = useState(0)
  // 圖片閱讀時間(秒)
  // useEffect(() => {
  //   setImagesReadingTime(30)
  // }, [])
  const completedHtml = `<h3>問卷正在提交中，請稍候。</h3><h3>請在成功頁面顯示後再離開。</h3><h4>如有填卷相關問題請洽：</h4> <a href='https://lin.ee/HWETcqy'>https://lin.ee/HWETcqy</a><h4 style='margin-top:50px'>填寫其他問卷：</h4> <a href=${window.location.origin}>${window.location.origin}</a>`

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const agreeSurvey = new Model(myAgreeJson)

  // 問卷編號
  // const pid = pid
  // 跳題 小心複選題要用陣列

  // const visibleIfConditionsInit = {
  //   q6: '{q5} = 0 or {q5} = 1 or {q5} = 2 or {q5} = 3',
  //   q7: '{q6} = ["none"]',
  //   q36: `{q35} <> ['none']`,
  // }

  const visibleIfConditionsInit = {
    q3: '{q2} = 1 or {q2} = 2 or {q2} = 3 or {q2} = 4',
  }
  // const visibleIfConditionsInit = null
  // const pageVisibleIfConditionsInit = null

  // 非必填(從 0 計算)
  // const notRequired = [100]
  const notRequired = null

  const mappedRateChoice = null
  // const pageBreakQuestions = ['q6', 'q11', 'q15']
  const pageBreakQuestions = null

  const triggersConditionsInit = [
    {
      type: 'complete',
      expression: `{q1} = 0 or ({q2} = 0) or ({q2} = 1) or ({q2} = 2 and {q3} = 0) or ({q2} = 2 and {q3} = 1) or ({q2} = 3 and {q3} = 0) or ({q2} = 3 and {q3} = 1) or ({q2} = 4 and {q3} = 0) or ({q2} = 2 and {q3} = 2 and {q4} = 3) or ({q2} = 2 and {q3} = 2 and {q4} = 4) or ({q2} = 2 and {q3} = 2 and {q4} = 5) or ({q2} = 2 and {q3} = 2 and {q4} = 6) or ({q2} = 2 and {q3} = 2 and {q4} = 7) or ({q2} = 2 and {q3} = 2 and {q4} = 8) or ({q2} = 2 and {q3} = 2 and {q4} = 9) or ({q2} = 2 and {q3} = 2 and {q4} = 10) or ({q2} = 2 and {q3} = 2 and {q4} = 11) or ({q2} = 2 and {q3} = 2 and {q4} = 12) or ({q2} = 2 and {q3} = 2 and {q4} = 13) or ({q2} = 2 and {q3} = 2 and {q4} = 14) or ({q2} = 2 and {q3} = 2 and {q4} = 15) or ({q2} = 2 and {q3} = 2 and {q4} = 16) or ({q2} = 2 and {q3} = 2 and {q4} = 17) or ({q2} = 2 and {q3} = 2 and {q4} = 18) or ({q2} = 2 and {q3} = 2 and {q4} = 19) or ({q2} = 2 and {q3} = 2 and {q4} = 20) or ({q2} = 2 and {q3} = 2 and {q4} = 21) or ({q2} = 2 and {q3} = 3 and {q4} = 3) or ({q2} = 2 and {q3} = 3 and {q4} = 4) or ({q2} = 2 and {q3} = 3 and {q4} = 5) or ({q2} = 2 and {q3} = 3 and {q4} = 6) or ({q2} = 2 and {q3} = 3 and {q4} = 7) or ({q2} = 2 and {q3} = 3 and {q4} = 8) or ({q2} = 2 and {q3} = 3 and {q4} = 9) or ({q2} = 2 and {q3} = 3 and {q4} = 10) or ({q2} = 2 and {q3} = 3 and {q4} = 11) or ({q2} = 2 and {q3} = 3 and {q4} = 12) or ({q2} = 2 and {q3} = 3 and {q4} = 13) or ({q2} = 2 and {q3} = 3 and {q4} = 14) or ({q2} = 2 and {q3} = 3 and {q4} = 15) or ({q2} = 2 and {q3} = 3 and {q4} = 16)  or ({q2} = 2 and {q3} = 3 and {q4} = 17) or ({q2} = 2 and {q3} = 3 and {q4} = 18) or ({q2} = 2 and {q3} = 3 and {q4} = 19) or ({q2} = 2 and {q3} = 3 and {q4} = 20) or ({q2} = 2 and {q3} = 3 and {q4} = 21) or({q2} = 2 and {q3} = 4 and {q4} = 3) or ({q2} = 2 and {q3} = 4 and {q4} = 4) or ({q2} = 2 and {q3} = 4 and {q4} = 5) or ({q2} = 2 and {q3} = 4 and {q4} = 6) or ({q2} = 2 and {q3} = 4 and {q4} = 7) or ({q2} = 2 and {q3} = 4 and {q4} = 8) or ({q2} = 2 and {q3} = 4 and {q4} = 9) or ({q2} = 2 and {q3} = 4 and {q4} = 10) or ({q2} = 2 and {q3} = 4 and {q4} = 11) or ({q2} = 2 and {q3} = 4 and {q4} = 12) or ({q2} = 2 and {q3} = 4 and {q4} = 13) or ({q2} = 2 and {q3} = 4 and {q4} = 14) or ({q2} = 2 and {q3} = 4 and {q4} = 15) or ({q2} = 2 and {q3} = 4 and {q4} = 16) or ({q2} = 2 and {q3} = 4 and {q4} = 17) or ({q2} = 2 and {q3} = 4 and {q4} = 18) or ({q2} = 2 and {q3} = 4 and {q4} = 19) or ({q2} = 2 and {q3} = 4 and {q4} = 20) or ({q2} = 2 and {q3} = 4 and {q4} = 21) or ({q2} = 3 and {q3} = 2 and {q4} = 3) or ({q2} = 3 and {q3} = 2 and {q4} = 4) or ({q2} = 3 and {q3} = 2 and {q4} = 5) or ({q2} = 3 and {q3} = 2 and {q4} = 6) or ({q2} = 3 and {q3} = 2 and {q4} = 7) or ({q2} = 3 and {q3} = 2 and {q4} = 8) or ({q2} = 3 and {q3} = 2 and {q4} = 9) or ({q2} = 3 and {q3} = 2 and {q4} = 10) or ({q2} = 3 and {q3} = 2 and {q4} = 11) or ({q2} = 3 and {q3} = 2 and {q4} = 12) or ({q2} = 3 and {q3} = 2 and {q4} = 13) or ({q2} = 3 and {q3} = 2 and {q4} = 14) or ({q2} = 3 and {q3} = 2 and {q4} = 15) or ({q2} = 3 and {q3} = 2 and {q4} = 16) or ({q2} = 3 and {q3} = 2 and {q4} = 17) or ({q2} = 3 and {q3} = 2 and {q4} = 18) or ({q2} = 3 and {q3} = 2 and {q4} = 19) or ({q2} = 3 and {q3} = 2 and {q4} = 20) or ({q2} = 3 and {q3} = 2 and {q4} = 21) or ({q2} = 3 and {q3} = 3 and {q4} = 3) or ({q2} = 3 and {q3} = 3 and {q4} = 4) or ({q2} = 3 and {q3} = 3 and {q4} = 5) or ({q2} = 3 and {q3} = 3 and {q4} = 6) or ({q2} = 3 and {q3} = 3 and {q4} = 7) or ({q2} = 3 and {q3} = 3 and {q4} = 8) or ({q2} = 3 and {q3} = 3 and {q4} = 9) or ({q2} = 3 and {q3} = 3 and {q4} = 10) or ({q2} = 3 and {q3} = 3 and {q4} = 11) or ({q2} = 3 and {q3} = 3 and {q4} = 12) or ({q2} = 3 and {q3} = 3 and {q4} = 13) or ({q2} = 3 and {q3} = 3 and {q4} = 14) or ({q2} = 3 and {q3} = 3 and {q4} = 15) or ({q2} = 3 and {q3} = 3 and {q4} = 16) or ({q2} = 3 and {q3} = 3 and {q4} = 17) or ({q2} = 3 and {q3} = 3 and {q4} = 18) or ({q2} = 3 and {q3} = 3 and {q4} = 19) or ({q2} = 3 and {q3} = 3 and {q4} = 20) or ({q2} = 3 and {q3} = 3 and {q4} = 21) or({q2} = 3 and {q3} = 4 and {q4} = 3) or ({q2} = 3 and {q3} = 4 and {q4} = 4) or ({q2} = 3 and {q3} = 4 and {q4} = 5) or ({q2} = 3 and {q3} = 4 and {q4} = 6) or ({q2} = 3 and {q3} = 4 and {q4} = 7) or ({q2} = 3 and {q3} = 4 and {q4} = 8) or ({q2} = 3 and {q3} = 4 and {q4} = 9) or ({q2} = 3 and {q3} = 4 and {q4} = 10) or ({q2} = 3 and {q3} = 4 and {q4} = 11) or ({q2} = 3 and {q3} = 4 and {q4} = 12) or ({q2} = 3 and {q3} = 4 and {q4} = 13) or ({q2} = 3 and {q3} = 4 and {q4} = 14) or ({q2} = 3 and {q3} = 4 and {q4} = 15) or ({q2} = 3 and {q3} = 4 and {q4} = 16) or ({q2} = 3 and {q3} = 4 and {q4} = 17) or ({q2} = 3 and {q3} = 4 and {q4} = 18) or ({q2} = 3 and {q3} = 4 and {q4} = 19) or ({q2} = 3 and {q3} = 4 and {q4} = 20) or ({q2} = 3 and {q3} = 4 and {q4} = 21) or ({q2} = 4 and {q3} = 1 and {q4} = 3) or ({q2} = 4 and {q3} = 1 and {q4} = 4) or ({q2} = 4 and {q3} = 1 and {q4} = 5) or ({q2} = 4 and {q3} = 1 and {q4} = 6) or ({q2} = 4 and {q3} = 1 and {q4} = 7) or ({q2} = 4 and {q3} = 1 and {q4} = 8) or ({q2} = 4 and {q3} = 1 and {q4} = 9) or ({q2} = 4 and {q3} = 1 and {q4} = 10) or ({q2} = 4 and {q3} = 1 and {q4} = 11) or ({q2} = 4 and {q3} = 1 and {q4} = 12) or ({q2} = 4 and {q3} = 1 and {q4} = 13) or ({q2} = 4 and {q3} = 1 and {q4} = 14) or ({q2} = 4 and {q3} = 1 and {q4} = 15) or ({q2} = 4 and {q3} = 1 and {q4} = 16) or ({q2} = 4 and {q3} = 1 and {q4} = 17) or ({q2} = 4 and {q3} = 1 and {q4} = 18) or ({q2} = 4 and {q3} = 1 and {q4} = 19) or ({q2} = 4 and {q3} = 1 and {q4} = 20) or ({q2} = 4 and {q3} = 1 and {q4} = 21) or ({q2} = 4 and {q3} = 2 and {q4} = 3) or ({q2} = 4 and {q3} = 2 and {q4} = 4) or ({q2} = 4 and {q3} = 2 and {q4} = 5) or ({q2} = 4 and {q3} = 2 and {q4} = 6) or ({q2} = 4 and {q3} = 2 and {q4} = 7) or ({q2} = 4 and {q3} = 2 and {q4} = 8) or ({q2} = 4 and {q3} = 2 and {q4} = 9) or ({q2} = 4 and {q3} = 2 and {q4} = 10) or ({q2} = 4 and {q3} = 2 and {q4} = 11) or ({q2} = 4 and {q3} = 2 and {q4} = 12) or ({q2} = 4 and {q3} = 2 and {q4} = 13) or ({q2} = 4 and {q3} = 2 and {q4} = 14) or ({q2} = 4 and {q3} = 2 and {q4} = 15) or ({q2} = 4 and {q3} = 2 and {q4} = 16) or ({q2} = 4 and {q3} = 2 and {q4} = 17) or ({q2} = 4 and {q3} = 2 and {q4} = 18) or ({q2} = 4 and {q3} = 2 and {q4} = 19) or ({q2} = 4 and {q3} = 2 and {q4} = 20) or ({q2} = 4 and {q3} = 2 and {q4} = 21) or({q2} = 4 and {q3} = 3 and {q4} = 3) or ({q2} = 4 and {q3} = 3 and {q4} = 4) or ({q2} = 4 and {q3} = 3 and {q4} = 5) or ({q2} = 4 and {q3} = 3 and {q4} = 6) or ({q2} = 4 and {q3} = 3 and {q4} = 7) or ({q2} = 4 and {q3} = 3 and {q4} = 8) or ({q2} = 4 and {q3} = 3 and {q4} = 9) or ({q2} = 4 and {q3} = 3 and {q4} = 10) or ({q2} = 4 and {q3} = 3 and {q4} = 11) or ({q2} = 4 and {q3} = 3 and {q4} = 12) or ({q2} = 4 and {q3} = 3 and {q4} = 13) or ({q2} = 4 and {q3} = 3 and {q4} = 14) or ({q2} = 4 and {q3} = 3 and {q4} = 15) or ({q2} = 4 and {q3} = 3 and {q4} = 16) or ({q2} = 4 and {q3} = 3 and {q4} = 17) or ({q2} = 4 and {q3} = 3 and {q4} = 18) or ({q2} = 4 and {q3} = 3 and {q4} = 19) or ({q2} = 4 and {q3} = 3 and {q4} = 20) or ({q2} = 4 and {q3} = 3 and {q4} = 21) or ({q2} = 4 and {q3} = 4 and {q4} = 3) or ({q2} = 4 and {q3} = 4 and {q4} = 4) or ({q2} = 4 and {q3} = 4 and {q4} = 5) or ({q2} = 4 and {q3} = 4 and {q4} = 6) or ({q2} = 4 and {q3} = 4 and {q4} = 7) or ({q2} = 4 and {q3} = 4 and {q4} = 8) or ({q2} = 4 and {q3} = 4 and {q4} = 9) or ({q2} = 4 and {q3} = 4 and {q4} = 10) or ({q2} = 4 and {q3} = 4 and {q4} = 11) or ({q2} = 4 and {q3} = 4 and {q4} = 12) or ({q2} = 4 and {q3} = 4 and {q4} = 13) or ({q2} = 4 and {q3} = 4 and {q4} = 14) or ({q2} = 4 and {q3} = 4 and {q4} = 15) or ({q2} = 4 and {q3} = 4 and {q4} = 16) or ({q2} = 4 and {q3} = 4 and {q4} = 17) or ({q2} = 4 and {q3} = 4 and {q4} = 18) or ({q2} = 4 and {q3} = 4 and {q4} = 19) or ({q2} = 4 and {q3} = 4 and {q4} = 20) or ({q2} = 4 and {q3} = 4 and {q4} = 21)`,
    },
  ]
  // const triggersConditionsInit = null
  // const pageVisibleIfConditionsInit = null

  const convertedSurvey = useConvertSurvey({
    survey: agreeSurvey,
    pid,
    setAc,
    setTk,
    ac,
    tk,
    setMyAgreeJson,
    imagesReadingTime,
    setImagesReadingTime,
    setIsLoading,
    completedHtml,
    visibleIfConditionsInit,
    notRequired,
    mappedRateChoice,
    pageBreakQuestions,
    requiresLogin,
    triggersConditionsInit,
  })

  // const newSurvey = new Model(convertedSurvey)

  const surveyModel = useMemo(() => {
    if (!convertedSurvey) return null
    return new Model(convertedSurvey)
  }, [convertedSurvey])

  // useEffect(() => {
  //   console.log('convertedSurvey', convertedSurvey)
  // }, [convertedSurvey])

  const endMessage = `很抱歉，目前與您相同特性的樣本已經額滿，沒辦法參與本次活動。歡迎您分享本問卷連結給其他親朋好友，或加入我們的<a href='https://lin.ee/HWETcqy'>LINE@</a>，隨時得到最新填問卷獲好禮的消息。<p>請按「完成」前往下載 EZChoice 或填寫更多問卷</p>`

  function helpFunction(survey, options) {
    // console.log('survey.getValue(q42)', survey.getValue('q42'))
    // 參考 P231113152849 或 P231101165555 或 P231206105643(政大帶入選項)
  }

  const endSurveyMsg = (survey) => {
    if (
      survey.getValue('q1') === 0 ||
      survey.getValue('q2') === 0 ||
      survey.getValue('q2') === 1 ||
      (survey.getValue('q2') === 2 && survey.getValue('q3') === 0) ||
      (survey.getValue('q2') === 2 && survey.getValue('q3') === 1) ||
      (survey.getValue('q2') === 3 && survey.getValue('q3') === 0) ||
      (survey.getValue('q2') === 3 && survey.getValue('q3') === 1) ||
      (survey.getValue('q2') === 4 && survey.getValue('q3') === 0) ||
      (survey.getValue('q2') === 2 &&
        survey.getValue('q3') === 2 &&
        survey.getValue('q4') >= 3) ||
      (survey.getValue('q2') === 2 &&
        survey.getValue('q3') === 3 &&
        survey.getValue('q4') >= 3) ||
      (survey.getValue('q2') === 2 &&
        survey.getValue('q3') === 4 &&
        survey.getValue('q4') >= 3) ||
      (survey.getValue('q2') === 3 &&
        survey.getValue('q3') === 2 &&
        survey.getValue('q4') >= 3) ||
      (survey.getValue('q2') === 3 &&
        survey.getValue('q3') === 3 &&
        survey.getValue('q4') >= 3) ||
      (survey.getValue('q2') === 3 &&
        survey.getValue('q3') === 4 &&
        survey.getValue('q4') >= 3) ||
      (survey.getValue('q2') === 4 &&
        survey.getValue('q3') === 1 &&
        survey.getValue('q4') >= 3) ||
      (survey.getValue('q2') === 4 &&
        survey.getValue('q3') === 2 &&
        survey.getValue('q4') >= 3) ||
      (survey.getValue('q2') === 4 &&
        survey.getValue('q3') === 3 &&
        survey.getValue('q4') >= 3) ||
      (survey.getValue('q2') === 4 &&
        survey.getValue('q3') === 4 &&
        survey.getValue('q4') >= 3)
    ) {
      setCompletionMessage(endMessage)
    } else {
      setCompletionMessage(
        `<h4 style='text-align: center'>問卷已成功送出</h4><h4 style='text-align: center'>請按「完成」前往下載 EZChoice 或填寫更多問卷</h4>`
      )
    }
    // else if (survey.getValue('q2') >= 15 && survey.getValue('q2') <= 39) {
    //   setCompletionMessage(
    //     `很抱歉，目前與您相同特性的樣本已經額滿，沒辦法參與本次活動。歡迎您分享本問卷連結給其他親朋好友，或加入我們的<a href='https://lin.ee/HWETcqy'>LINE@</a>，隨時得到最新填問卷獲好禮的消息。<p>請按「完成」前往下載 EZChoice 或填寫更多問卷</p>`
    //   )
    // }
  }

  const canShowPrevButtonPages = null
  const choicesOrderRef = useRef({})
  const choiceIndexMapRef = useRef({})

  useSubmitAnswers({
    survey: surveyModel,
    pid,
    ac,
    tk,
    imagesReadingTime,
    setIsLoading,
    helpFunction,
    canShowPrevButtonPages,
    choicesOrderRef,
    choiceIndexMapRef,
    endSurveyMsg,
  })

  return (
    <>
      {surveyModel ? (
        <Survey model={surveyModel} key={pid} />
      ) : myAgreeJson ? (
        <Survey model={agreeSurvey} />
      ) : (
        <></>
      )}
    </>
  )
}

export default Agree
